<template>
    <div style="padding: 15px;height: 100vh">
        <div v-if="render_type != 'edit_user_admin'" class="app-content">
            <a-spin :spinning="loading">
                <a-card :title="title">
                    <template #extra>
                        <a-space>
                            <a-button style="display: flex;"
                                type="primary" size="large" @click="showModalExport = true">
                                {{ button_title }}
                            </a-button>
                            <a-button style="display: flex" @click="$router.go(-1)" type="primary" size="large">
                                <template #icon>
                                    <span class="material-symbols-outlined">arrow_back_ios</span>
                                </template>
                                ย้อนกลับ
                            </a-button>
                        </a-space>
                    </template>

                    <a-row>
                        <a-space>
                            <a-input-search style="width: 300px;" v-model:value="search_username" :placeholder="`ค้นหาชื่อผู้ส่งคำขอ`" enter-button="Search"/>
                            <a-range-picker v-model:value="timeStart" />
                        </a-space>
                        <a-button @click="clear_search" type="dashed" style="margin-left: 1rem">CLEAR</a-button>
                    </a-row>

                    <br>
                    <a-row>
                        <a-table :columns="filteredColumns" :data-source="filtered_list(Leave_progress2)" bordered size="small" :scroll="{ x: 'calc(100px + 50%)', y: '100%' }">
                            <template #bodyCell="{ column, record }">
                                <template v-if="column.key === 'fullname'">
                                    <div> {{ record.fullname }} </div>
                                </template>
                                <template v-if="column.key === 'withdraw_user_timestamp'">
                                    <div> {{ render_date(record.withdraw_user_timestamp) }} </div>
                                </template>
                                <template v-if="column.key === 'time_start'">
                                    <div> {{ render_date(record.time_start) }} </div>
                                </template>
                                <template v-if="column.key === 'leave_type_id'">
                                    <div> {{ getLeaveTypeName(record.leave_type_id) }} </div>
                                </template>
                                <template v-if="column.key === 'claim_type_id'">
                                    <div> {{ getLeavePatternTypeName(record.claim_type_id) }} </div>
                                </template>
                                <template v-if="column.key === 'withdraw_user_amount'">
                                    <div> {{Number(record.withdraw_user_amount).toLocaleString() }} </div>
                                </template>
                                <template v-if="column.key === 'approve_status'">
                                    <div :style="{ color: record.approve_status == 1 ? 'green' : record.approve_status == 2 ? 'red' : '' }">
                                        {{ getApproveStatusName(record.approve_status) }}
                                    </div>
                                </template>
                                <template v-if="column.key === 'leave_quota'">
                                    <div> {{record.leave_quota}} </div>
                                </template>
                                <template v-if="column.key === 'approver'">
                                    <div>{{ record.approver }}</div>
                                </template>
                                <template v-if="column.key === 'id'">
                                    <div>
                                        <a><span style="font-size: 14px" class="material-symbols-outlined" @click="showLeaveDetails(record)">Visibility</span></a>
                                    </div>
                                </template>
                            </template>
                        </a-table>
                    </a-row>
                    <a-modal v-model:visible="showModalLeaveUserData" @ok="showModalLeaveUserData=false" >
                        <div style="display: flex; flex-direction: column ;justify-items:start;align-items: start">
                            <a-form-item label="ชื่อ-นามสกุล ผู้ส่งคำขอ" name="leave_user_no" style="width: 98%; margin-top: 5%;">
                                <a-input :value="selectedLeave.fullname" placeholder="ชื่อ-นามสกุล ผู้ส่งคำขอ" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="เลขกำกับใบเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="selectedLeave.withdraw_user_no" placeholder="เลขกำกับใบเบิก" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="วันที่แจ้งเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="render_date(selectedLeave.withdraw_user_timestamp)" placeholder="วันที่แจ้งเบิก" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="วันที่ขอเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="render_date(selectedLeave.time_start)" placeholder="วันที่ขอเบิก" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="ประเภทการเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="getLeavePatternTypeName(selectedLeave.claim_type_id)" placeholder="ประเภทการเบิก" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="การอนุมัติ" name="leave_user_no" style="width: 98%;">
                                <a-input :value="getApproveStatusName(selectedLeave.approve_status)" placeholder="การอนุมัติ" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="เหตุผลการขอเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="selectedLeave.withdraw_user_remark" placeholder="เหตุผลการขอเบิก" disabled></a-input>
                            </a-form-item>
                            <p>ใบรูปหลักฐานการโอน:</p>
                            <div v-if="selectedLeave.photo_1 != null && selectedLeave.photo_1 != ''" class="image-container" style="margin-top: -5px; margin-bottom: 15px;">
                                <img :src="selectedLeave.photo_1" class="uploaded-image-table" alt="uploaded image" />
                                <div class="icon-container">
                                    <span class="material-symbols-outlined preview-icon" @click="showPreview($event, selectedLeave.photo_1)">
                                        visibility
                                    </span>
                                    <span class="material-symbols-outlined download-icon"
                                        @click="getBase64Image($event, selectedLeave.photo_1)">
                                        download
                                    </span>
                                </div>
                            </div>
                            <a-form-item label="หมายเหตุ" name="leave_user_remark" style="width: 98%;">
                                <a-textarea :value="selectedLeave.withdraw_admin_remark" placeholder="หมายเหตุ" :rows="3" disabled></a-textarea>
                            </a-form-item>
                            <a-form-item label="ชื่อผู้อนุมัติการเบิก" name="approver" style="width: 98%; margin-top: 6%;">
                                    <a-select v-if="businessTypeId === 3" style="width: 100%;" placeholder="ชื่อผู้อนุมัติ" v-model:value="selectedLeave.approver" disabled
                                        @change="(value) => handleChangeApprover(selectedLeave.id, value)">
                                        <a-select-option
                                            v-for="({ fullname }, i) in administrative"
                                            :key="i"
                                            :value="fullname"
                                            >
                                            {{ fullname }}
                                        </a-select-option>
                                    </a-select>
                            </a-form-item>
                        </div>
                        <template #footer>
                            <a-button type="primary" @click="showModalLeaveUserData=false">
                                ปิด
                            </a-button>
                        </template> 
                    </a-modal> 
                    <a-modal :title="'ออกรายงานการเบิก'" v-model:visible="showModalExport" @ok="showModalExport=false" >
                        <a-form layout="vertical">
                            <a-row type="flex">
                                <a-col :span="24">
                                    <a-form-item label="ผู้ส่งคำขอ" style="width: 98%;" :rules="[{ required: true, message: 'กรุณากรอกผู้ส่งคำขอ' }]">
                                        <a-select v-model:value="search_leave_user" placeholder="ผู้ส่งคำขอ">
                                            <a-select-option
                                                v-for="({ id, fullname }, i) in manage_user_list"
                                                :key="i"
                                                :value="fullname"
                                            >{{ fullname }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item style="width: 98%;" :rules="[{ required: true, message: 'กรุณากรอกประเภทการเบิก' }]">
                                        <span style="color: red; margin-right: 3px;">*</span><span>ประเภทการเบิก</span>
                                        <a-checkbox v-model="allLeaveTypes" style="margin-left: 8px; margin-right: 5px;" @change="handleCheckboxChange">
                                            ทั้งหมด
                                        </a-checkbox>
                                        <a-select v-model:value="search_leave_type" placeholder="ประเภทการเบิกเงิน" :disabled="allLeaveTypes == true">
                                            <a-select-option
                                                v-for="({ id, name }, i) in leave_pattern_list"
                                                :key="i"
                                                :value="id"
                                            >{{ name }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="24">
                                    <a-form-item label="วันที่เริ่ม" style="width: 98%;" :rules="[{ required: true, message: 'กรุณากรอกวันที่เริ่ม' }]">
                                        <a-range-picker v-model:value="search_start_date" format="DD/MM/YYYY" style="width: 460px"
                                        :placeholder="['Start Date', 'End Date']" :minuteStep="1" :ranges="ranges" />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-form>
                        <template #footer>
                            <a-button type="primary" @click="validateFields">
                                บันทึก
                            </a-button>
                        </template> 
                    </a-modal> 
                    <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false"
                        class="custom-modal" style="background-color: none !important">
                        <img :src="previewImage" alt="Preview" style="width: 100%;" />
                    </a-modal>
                </a-card>
            </a-spin>
        </div>
    </div>
</template>

<script>
import Utility from '../../utility'
import Swal from 'sweetalert2'
import SystemService from '../../api/SystemService'
import AdminService from '../../api/AdminService';
import UserService from '../../api/UserService';
import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import CompanyService from '../../api/CompanyService'

dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
// import * as XLSX from 'xlsx';
import * as XLSX from "xlsx-js-style";
import LeaveService from '../../api/LeaveService';
import AccountingService from '../../api/AccountingService';
import LeaveAdminService from '../../api/LeaveAdminService';
import WithdrawAdminService from '../../api/WithdrawAdminService';
import AdministrativeService from '../../api/AdministrativeService';
export default {
    name: 'LeaveAdmin',
    computed: {
        uniqueLeaveProgress2() {
        const uniqueUsers = [];
        const userNames = new Set();
        this.Leave_progress2.forEach(item => {
            if (!userNames.has(item.fullname)) {
            userNames.add(item.fullname);
            uniqueUsers.push(item);
            }
        });
        return uniqueUsers;
        },
        filteredColumns() {
            if (Array.isArray(this.columns)) {
                return this.columns.filter(column => {
                    if(this.businessTypeId != 3 && this.businesssTypeId != 2){
                        return column.key !== 'leave_pattern_id'
                    }
                    // ซ่อน leave_quota เมื่อ business เป็น false
                    return column.key !== 'leave_quota' || this.business;
                });
            }
            // ถ้า columns ไม่ใช่ array ให้คืนค่าเป็น array เปล่า
            return [];
        
        },
        leave_quota_limits() {
            return this.businessTypeId === 4
                ? {
                    1: 7,  // ลากิจ: 7 ครั้ง/ปี
                    2: 12,  // ลาพักร้อน: 12 ครั้ง/ปี
                    4: 30, // ลาป่วย: 30 ครั้ง/ปี
                    6: null, // ลาชาปนกิจ: ไม่มีเงื่อนไข
                }
                : {
                    1: 3,  // ลากิจ: 3 ครั้ง/ปี
                    2: 8,  // ลาพักร้อน: 8 ครั้ง/ปี
                    7: 4,  // ลาฝึกอบรม: 4 ครั้ง/ปี
                    4: 30, // ลาป่วย: 30 ครั้ง/ปี
                    5: null, // ลาแบบไม่รับค่าจ้าง: ไม่มีเงื่อนไข
                    6: null, // ลาชาปนกิจ: ไม่มีเงื่อนไข
                };
        },
    },
    data() {
        return {
            leave_quota_data: [], // ดึงข้อมูลโควตาจาก API
            businessTypeId: null,
            leave_pattern_list:[
                {id: 1, name:'เงินสด'},
                {id: 2, name:'เงินโอน'},
            ],
            previewImage: "",
            previewVisible: false,
            allLeaveTypes: false,
            showModalExport: false,
            search_username: null,
            search_leave_user: null,
            search_leave_type: null,
            search_start_date: null,
            search_end_date: null,
            Leave_progress2: [],
            selectedLeave: {},
            showModalLeaveUserData: false,
            timeStart: null,
            timeEnd: null,
            loading: false,
            search_business_type: null,

            img_placeholder: require('@/assets/images/place-holder/placeholder.jpg'),
            show_table_list: [],
            leave_types: [],
            business: false,
            filtered_leave_types: [],
            operations: [],
            accounting: [],
            adminOperation: [],
            administrative: [],
            fileList: [],
            pagination: {
                page: 1,
                perPage: 10,
            },
            manage_user_list: [],
            title: 'ประวัติการแจ้งเบิก',
            button_title: 'ออกรายงานการเบิก',
            columns: [
                {
                    title: 'ชื่อ-นามสกุล ผู้ส่งคำขอ',
                    dataIndex: 'fullname',
                    key: 'fullname',
                    width: 200,
                    align: 'center',
                },
                {
                    title: 'วันที่แจ้งเบิก',
                    dataIndex: 'withdraw_user_timestamp',
                    key: 'withdraw_user_timestamp',
                    width: 120,
                    align: 'center',
                }, 
                {
                    title: 'วันที่ขอเบิก',
                    dataIndex: 'time_start',
                    key: 'time_start',
                    width: 180,
                    align: 'center',
                }, 
                {
                    title: 'เลขกำกับใบเบิก',
                    dataIndex: 'withdraw_user_no',
                    key: 'withdraw_user_no',
                    width: 150,
                    align: 'center',
                }, 
                {
                    title: 'ปรเภทการเบิกเงิน',
                    dataIndex: 'claim_type_id',
                    key: 'claim_type_id',
                    width: 120,
                    align: 'center',
                },
                {
                    title: 'จำนวนขอเบิก',
                    dataIndex: 'withdraw_user_amount',
                    key: 'withdraw_user_amount',
                    width: 90,
                    align: 'center',
                },
                {
                    title: 'การอนุมัติ',
                    dataIndex: 'approve_status',
                    key: 'approve_status',
                    width: 150,
                    align: 'center',
                }, 
                {
                    title: 'ชื่อผู้อนุมัติการเบิก',
                    dataIndex: 'approver',
                    key: 'approver',
                    width: 210,
                    align: 'center',
                }, 
                {
                    title: 'ตัวเลือก',
                    dataIndex: 'id',
                    key: 'id',
                    width: 130,
                    align: 'center',
                    fixed: 'right'
                }
            ],
        }
    },
    watch: {
        'detail.leave_type_id': function () {
                this.updateLeaveQuota();
            },
    },
    methods: {
        getLeavePatternTypeName(id) {
            const leaveType = this.leave_pattern_list.find(type => type.id === id);
            return leaveType ? leaveType.name : '';
        },
        async getBase64Image(e, file) {
            e.stopPropagation();
            e.preventDefault();

            if (typeof file === 'string') {
                const result = await this.getBase64ImageFromURL(file);
                let a = document.createElement('a');
                a.href = result;
                a.download = 'image.png';
                a.click();
            } else if (file.url) {
                const result = await this.getBase64ImageFromURL(file.url);

                // download
                let a = document.createElement('a');
                a.href = result;
                a.download = 'image.png';
                a.click();
            } else {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => {
                    const base64String = reader.result;
                    let a = document.createElement('a');
                    a.href = base64String;
                    a.download = 'image.png';
                    a.click();
                };
            }
        },
        showPreview(e, fileUrl) {
            e.stopPropagation();
            this.previewImage = fileUrl;
            this.previewVisible = true;
        },
        async getBase64ImageFromURL(url) {
            const res = await fetch(url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer'
            });
            const blob = await res.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        handleCheckboxChange() {
            this.allLeaveTypes = !this.allLeaveTypes;
            if (this.allLeaveTypes) {
                this.search_leave_type = null;
            }
        },
        validateFields() {
            const isUserValid = !!this.search_leave_user;
            const isTypeValid = this.allLeaveTypes || !!this.search_leave_type;
            const isStartDateValid = !!this.search_start_date;
            const isEndDateValid = !!this.search_start_date;

            if (!isUserValid) {
                this.$message.error('กรุณากรอกผู้ส่งคำขอ');
            }
            if (!isTypeValid) {
                this.$message.error('กรุณากรอกประเภทการเบิก');
            }
            if (!isStartDateValid) {
                this.$message.error('กรุณากรอกวันที่เริ่ม');
            }
            if (!isEndDateValid) {
                this.$message.error('กรุณากรอกวันที่สิ้นสุด');
            }

            if (isUserValid && isTypeValid && isStartDateValid && isEndDateValid) {
                this.import_export_dropdown();
            }
        },
        import_export_dropdown() {
            this.export_file()
            this.showModalExport = false
        },
        async export_file() {
            this.$message.loading({ content: "กำลังโหลด...", key: "loading" });

            let data = await WithdrawAdminService.getWithdrawAdminAll()
            data = this.Leave_progress2.filter(item => item.withdraw_progress == 2)
            
                const filteredData = this.Leave_progress2.filter(item => {
                const matchesUser = !this.search_leave_user || (item.fullname && item.fullname.includes(this.search_leave_user));
                const matchesType = this.allLeaveTypes || item.claim_type_id === this.search_leave_type;
                const matchesStartDate = !this.search_start_date[0] || dayjs(item.time_start).isSameOrAfter(dayjs(this.search_start_date[0]).startOf('day'));
                const matchesEndDate = !this.search_start_date[1] || dayjs(item.time_start).isSameOrBefore(dayjs(this.search_start_date[1]).endOf('day'));
                const matchesDate = matchesStartDate && matchesEndDate;
                return matchesUser && matchesType && matchesDate;
            }).map(item => {
                const baseItem = {
                    fullname: item.fullname || '-',
                    withdraw_user_timestamp: item.withdraw_user_timestamp
                        ? `${dayjs(item.withdraw_user_timestamp).format('YYYY/MM/DD')}` : '-',
                    time_start: item.time_start
                        ? `${dayjs(item.time_start).format('YYYY/MM/DD')}` : '-',
                    withdraw_user_no: item.withdraw_user_no || '-',
                    claim_type_id: this.getLeavePatternTypeName(item.claim_type_id) || '-',
                    withdraw_user_amount: item.withdraw_user_amount || '-',
                    approve_status: this.getApproveStatusName(item.approve_status) || '-',
                    approver: item.approver || '-',
                };

                // Add leave_quota only if business is true

                return baseItem;
            });

            const headersColumn = [
                { header: "ชื่อ-นามสกุล ผู้ส่งคำขอ", key: "fullname" },
                { header: "วันที่แจ้งเบิก", key: "withdraw_user_timestamp" },
                { header: "วันที่ขอเบิก", key: "time_start" },
                { header: "เลขกำกับใบเบิก", key: "withdraw_user_no" },
                { header: "ปรเภทการเบิกเงิน", key: "claim_type_id" },
                { header: "จำนวนขอเบิก", key: "withdraw_user_amount" },
                { header: "การอนุมัติ", key: "approve_status" },
                { header: "ชื่อผู้อนุมัติการเบิก", key: "approver" },
            ];

            const workBook = XLSX.utils.book_new();
            const workSheet = XLSX.utils.json_to_sheet(filteredData, { header: headersColumn.map(h => h.key) });

            XLSX.utils.sheet_add_aoa(workSheet, [headersColumn.map(h => h.header)], { origin: 'A1' });

            headersColumn.forEach((header, colIndex) => {
                const cellAddress = XLSX.utils.encode_cell({ c: colIndex, r: 0 });
                const cell = workSheet[cellAddress];
                if (cell) {
                    cell.s = {
                        font: { bold: true, color: { rgb: "000000" } }, // color text
                        fill: { fgColor: { rgb: "d3dfe2" } }, // color background
                        alignment: { horizontal: "center", vertical: "center" },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } }
                        }
                    };
                }
            });

            const range = XLSX.utils.decode_range(workSheet['!ref']);
            for (let R = range.s.r + 1; R <= range.e.r; ++R) {
                for (let C = range.s.c; C <= range.e.c; ++C) {
                    const cellAddress = XLSX.utils.encode_cell({ c: C, r: R });
                    const cell = workSheet[cellAddress];
                    if (cell) {
                        cell.s = cell.s || {};
                        cell.s.alignment = { horizontal: "center", vertical: "center" };
                        cell.s.border = {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } }
                        };
                    }
                }
            }

            workSheet['!cols'] = [
                { wch: 50 },
                { wch: 25 },
                { wch: 45 },
                { wch: 30 },
                { wch: 20 },
                { wch: 22 },
                { wch: 20 },
                { wch: 30 },
                { wch: 30 },
            ];

            XLSX.utils.book_append_sheet(workBook, workSheet, "Report");
            XLSX.writeFile(workBook, "Withdraw.xlsx");
            this.$message.success({ content: "โหลดข้อมูลสำเร็จ", key: "loading" });
        },
        remove_leave_user(id){
            Swal.fire({
                title: 'คุณต้องการลบใช่หรือไม่??',
                text: `คุณจะไม่สามารถกู้คืนได้`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ใช่',
                cancelButtonText: 'ยกเลิก'
                }).then(async (result) => {
                if (result.isConfirmed) {
                    await SystemService.delete_all('WithdrawAdmin', id)
                    this.onRefresh()
                }
            })
        },
        showLeaveDetails(record) {
            this.selectedLeave = record;
            this.showModalLeaveUserData = true;
        },
        onRefresh() {
             this.init_leave_admins()
        },
        async handleChangeApproveStatus(id, value) {
            await SystemService.update_all('withdrawAdmin', { data: { approve_status: value } }, id);
            this.onRefresh();
        },
        async handleChangeApprover(id, fullname) {
            await SystemService.update_all('withdrawAdmin', { data: { approver: fullname} }, id);
            this.onRefresh();
        },
        clear_search() {
            this.search_username = null;
            this.timeStart = null;
            this.timeEnd = null;
        },
        render_date(datetime) {
            return dayjs(datetime).format('YYYY/MM/DD')
        },
        filtered_list(array) {
            return array.filter(({ fullname, time_start, time_end }) => {
                let matchesName = true;
                let matchesDateRange = true;
                if (this.search_username) {
                    matchesName = fullname ? fullname.toLowerCase().includes(this.search_username.toLowerCase()) : false;
                }
                // ตรวจสอบช่วงวันที่ (ไม่สนใจเวลา)
                if (this.timeStart) {
                    const filterStart = dayjs(this.timeStart[0]).startOf('day');
                    const filterEnd = dayjs(this.timeStart[1]).endOf('day');
                    const target = dayjs(time_start);
                    matchesDateRange = target.isSameOrAfter(filterStart) && target.isSameOrBefore(filterEnd);
                }
                return matchesName && matchesDateRange;
            });
        },
        async init_leave_pattern(){
            this.leave_pattern_list = await LeaveService.getLeavePatternAll();
        },
        async init_leave_admins() {
            try {
                this.Leave_progress2 = await WithdrawAdminService.getWithdrawAdminAll()
                this.Leave_progress2 = this.Leave_progress2.filter(item => item.withdraw_progress == 2)
                this.administrative = await AdministrativeService.getAdministrativeByCompany()
            } catch (error) {
                console.error('Error initializing leave admins:', error);
            }
        },
        handleTableChange(pagination, filters, sorter) {
			// console.log({pagination, filters, sorter});
			this.pagination.page = pagination.current;
            this.pagination.perPage = pagination.pageSize;
			this.onRefresh();
		},
        async init_users() {
            const data = await CompanyService.getManageUsers(this.pagination.page, this.pagination.perPage)
            const data_no_sale = data.data.filter(a => a.role !== 'sale')
            this.pagination = data
            this.manage_user_list = this.businessTypeId === 3 ? data_no_sale:data.data
        },
        getLeaveTypeName(id) {
            const leaveType = this.leave_types.find(type => type.id === id);
            return leaveType ? leaveType.name : '';
        },
        getApproveStatusName(status) {
            if (status == 1) {
                return 'อนุมัติ';
            } else if (status == 2) {
                return 'ไม่อนุมัติ';
            } else {
                return '';
            }
        },
        async getBusinessType(){
            const company = await UserService.get_user_profile();
            const businessType = await CompanyService.getBusinessId(company.company_id)
            this.businessTypeId = businessType.data
        },
        async get_company() {
			const company = await UserService.get_user_profile();
            const businessType = await CompanyService.getBusinessId(company.company_id)
            this.businessTypeId = businessType.data
            if ( businessType.data === 2 || businessType.data === 3 || businessType.data === 4)
            {
                this.business = true
            }
        },
        updateLeaveQuota() {
            if (this.detail.leave_type_id) {
                const quota = this.leave_quota_data.find(
                    (item) => item.leave_type_id === this.detail.leave_type_id
                );
                const usedQuota = quota ? quota.count : 0; // จำนวนที่ใช้ไป
                const totalQuota = this.leave_quota_limits[this.detail.leave_type_id]; // โควตาทั้งหมด

                if (totalQuota !== null) {
                    this.detail.leave_quota = `${usedQuota}/${totalQuota}`; // เช่น "1/3"
                } else {
                    this.detail.leave_quota = `-`; // ไม่มีเงื่อนไข
                }
            }
        },
    },
    async mounted() {
        await this.getBusinessType();
        this.init_leave_admins().then(() => {
            this.init_users()
        this.get_company().then(() => {
        });
    });
    }
}
</script>

<style>
.preview-icon,
.download-icon {
    cursor: pointer;
    font-size: 20px;
    color: black;
}
.image-container {
    position: relative;
    display: inline-block;
}
.uploaded-image-table {
    display: block;
    width: 15rem;
    height: auto;
}
.icon-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    padding: 5px;
}

.permission-table .ant-table-row-level-0 td:first-child,
.permission-table .ant-table-row-level-0 td:nth-child(2),
.permission-table .ant-table-row-level-0 td:nth-child(3) {
    background-color: #f9f9f9 !important;
}
.permission-table .ant-table-row-expand-icon::before,
.permission-table .ant-table-row-expand-icon::after 
{
    content: '' !important;
    border: none !important;
    background: none; /* ปิด background */
    transform: none !important;
    transition: none !important;
    top: auto !important
}
.permission-table .ant-table-row-expand-icon:not(.ant-table-row-expand-icon-expanded)::before {
    content: '>' !important;
}

.permission-table .ant-table-row-expand-icon.ant-table-row-expand-icon-expanded::before {
    content: 'v' !important;
}
</style>